<template>
    <el-dialog title="Famille" :visible.sync="thisvisible">
        <div class="form-container">
            <div v-loading="loading" class="form-container">
                <el-form
                    ref="familleForm"
                    :model="thisfamille"
                    :rules="rules"
                    label-position="left"
                    label-width="150px"
                    style="max-width: 500px;"
                >
                    <el-form-item
                        label="Nom"
                        prop="nom"
                        :error="getErrorForField('nom', errors)"
                    >
                        <el-input v-model="thisfamille.nom" />
                    </el-form-item>
                    <el-form-item
                        label="Max"
                        prop="max"
                        :error="getErrorForField('max', errors)"
                    >
                        <el-input v-model="thisfamille.max" />
                    </el-form-item>
                    <el-form-item
                        label="Description"
                        prop="description"
                        :error="getErrorForField('description', errors)"
                    >
                        <el-input
                            type="textarea"
                            v-model="thisfamille.description"
                        />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="thisvisible = false">
                            Annuler
                        </el-button>
                        <el-button type="primary" @click="save">
                            Enregistrer
                        </el-button>
                        <el-button type="danger" @click="supprimer">
                            Supprimer
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import Resource from "@/api/resource";
const familleResource = new Resource("familles");

export default {
    name: "Famille",
    props: {
        isvisible: {
            type: Boolean,
            default: false
        },
        famille: {
            type: Object,
            default: () => {
                return {
                    nom: "",
                    max: 8,
                    description: ""
                };
            }
        },
        parent: {
            type: Object
        }
    },
    data() {
        return {
            thisvisible: false,
            loading: false,
            rules: {},
            errors: [],
            thisfamille: {
                nom: "",
                max: 8,
                description: ""
            }
        };
    },
    watch: {
        isvisible(val) {
            if (val) {
                this.thisvisible = val;
                this.errors = [];
                if (this.famille) {
                    Object.assign(this.thisfamille, this.famille);
                }
            }
        },
        thisvisible(val) {
            if (!val) {
                this.parent.dialogFamilleVisible = val;
                this.errors = [];
            }
        }
    },
    computed: {},
    methods: {
        save() {
            this.errors = [];
            this.loading = true;
            if (this.thisfamille.id) {
                familleResource
                    .update(this.thisfamille.id, this.thisfamille)
                    // .then(response => {
                    .then(response => {
                        this.loading = false;
                        this.parent.callbackFamille(false, response.data);
                        this.thisvisible = false;
                        this.$message({
                            message: "Famille mise à jour",
                            type: "success",
                            duration: 5 * 1000
                        });
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            } else {
                familleResource
                    .store(this.thisfamille)
                    .then(response => {
                        this.loading = false;
                        this.thisvisible = false;
                        this.$message({
                            message: "Famille créée",
                            type: "success",
                            duration: 5 * 1000
                        });
                        console.log(response);
                        this.parent.callbackFamille(true, false);
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            }
        },
        supprimer() {
            this.$confirm(
                "Voulez-vous supprimer cette Famille",
                "Attention",
                {
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Anuler",
                    type: "warning"
                }
            )
                .then(() => {
                    this.loading = true;
                    familleResource
                        .destroy(this.thisfamille.id)
                        .then(response => {
                            console.log(response);
                            this.loading = false;
                            this.thisvisible = false;
                            this.$message({
                                type: "success",
                                message: "Suppression effectuée"
                            });
                            this.parent.callbackFamille(true, false);
                        })
                        .catch(error => {
                            console.log(error);
                            this.loading = false;
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "Suppression Anulée"
                    });
                });
        },
        getErrorForField(field, errors) {
            if (errors && errors[field]) {
                return errors[field].join(" ");
            }
        }
    }
};
</script>
